import { useEffect, useState } from "react";
import { fetchVerificationStatus } from "../api/authService";
import { Toast } from "./Toast";

const VerificationNotice = () => {
    const [isVerified, setIsVerified] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const token = localStorage.getItem("token");

    useEffect(() => {
        if (!token) return;
        const checkVerification = async () => {
            const { response, error } = await fetchVerificationStatus();
            if (!error) setIsVerified(response);
        };
        checkVerification();
    }, [token]);

    const handleResendVerification = async () => {
        setIsLoading(true);
        try {
            const response = await fetch("https://latangelarogers.com/wp-json/custom-auth/v1/resend-verification", {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });
            const data = await response.json();
            Toast.default(data.message);
        } catch (error) {
            Toast.default("Failed to resend verification email.");
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    if (!token || isVerified) return null;

    return (
        <>
            <div className="bg-gradient-to-r from-yellow-500 to-black text-yellow-800 p-3 text-center flex justify-between items-center px-20">
                <span>Your email is not verified. Please check your email inbox to verify your account.</span>
                <button
                    onClick={handleResendVerification}
                    className="bg-white text-yellow-700 px-3 py-1 rounded font-semibold hover:bg-gray-200 transition"
                    disabled={isLoading}
                >
                    {isLoading ? "Resending..." : "Resend Email"}
                </button>
            </div>
            <div className="fixed top-0 left-0 w-full bg-black/60 text-white p-3 text-center flex justify-between items-center z-50 px-20 backdrop-blur-md">
                <span>Your email is not verified. Please check your email inbox to verify your account.</span>
                <button
                    onClick={handleResendVerification}
                    className="bg-white text-yellow-700 px-3 py-1 rounded font-semibold hover:bg-gray-200 transition"
                    disabled={isLoading}
                >
                    {isLoading ? "Resending..." : "Resend Email"}
                </button>
            </div>
        </>
    );
};

const VerificationNotice_ = () => {
    const [isVerified, setIsVerified] = useState(true); // Assume verified by default
    const [loading, setLoading] = useState(false);
    const token = localStorage.getItem("token");

    useEffect(() => {
        if (!token) return; // Don't check if user is not logged in

        const fetchVerificationStatus = async () => {
            try {
                const response = await fetch("https://latangelarogers.com/wp-json/wp/v2/users/me", {
                    headers: { Authorization: `Bearer ${token}` },
                });
                const data = await response.json();
                if (response.ok) {
                    setIsVerified(data.is_verified);
                }
            } catch (error) {
                console.error("Error checking verification status:", error);
            }
        };

        fetchVerificationStatus();
    }, [token]);

    const handleResendEmail = async () => {
        setLoading(true);
        try {
            const response = await fetch("https://latangelarogers.com/wp-json/custom/v1/resend-verification", {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });
            const data = await response.json();
            alert(data.message || "Verification email sent!");
        } catch (error) {
            alert("Failed to resend verification email.");
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    if (!token || isVerified) return null; // Don't show anything if user is verified or not logged in

    return (
        <div className="bg-yellow-500 text-white text-center py-2 px-4 flex justify-between items-center">
            <span>Please verify your email before using the platform. Check your inbox.</span>
            <button
                onClick={handleResendEmail}
                className="bg-white text-yellow-700 px-3 py-1 rounded font-semibold hover:bg-gray-200 transition"
                disabled={loading}
            >
                {loading ? "Resending..." : "Resend Email"}
            </button>
        </div>
    );
};

export default VerificationNotice;
